import React from 'react';

const Logo = ({ size = 'default', showText = true, className = '' }) => {
  const sizes = {
    small: { icon: 32, text: 'text-lg' },
    default: { icon: 40, text: 'text-xl' },
    large: { icon: 56, text: 'text-3xl' },
    xlarge: { icon: 72, text: 'text-4xl' }
  };

  const { icon: iconSize, text: textSize } = sizes[size] || sizes.default;

  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <div className="flex-shrink-0" style={{ width: iconSize, height: iconSize }}>
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" style={{ filter: 'drop-shadow(0 2px 4px rgba(232, 163, 23, 0.3))' }}>
          <circle cx="32" cy="28" r="25" stroke="#E8A317" strokeWidth="3.5" fill="none" />
          <path d="M 10 38 L 32 58 L 54 38" fill="#E8A317" stroke="#E8A317" strokeWidth="3.5" strokeLinejoin="round" />
          <text x="32" y="38" textAnchor="middle" fontFamily="Arial, Helvetica, sans-serif" fontWeight="bold" fontSize="32" fill="#E8A317">P</text>
        </svg>
      </div>
      {showText && (
        <div className="flex flex-col leading-none">
          <span className={`${textSize} font-bold text-white tracking-tight`}>Phantom Trades</span>
          <span className="text-[9px] font-semibold tracking-[0.25em] text-gray-400 uppercase mt-0.5">Trade Smart</span>
        </div>
      )}
    </div>
  );
};

export const LogoCompact = ({ className = '' }) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <div className="flex-shrink-0" style={{ width: 30, height: 30 }}>
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <circle cx="32" cy="28" r="25" stroke="#E8A317" strokeWidth="3.5" fill="none" />
        <path d="M 10 38 L 32 58 L 54 38" fill="#E8A317" stroke="#E8A317" strokeWidth="3.5" strokeLinejoin="round" />
        <text x="32" y="38" textAnchor="middle" fontFamily="Arial, Helvetica, sans-serif" fontWeight="bold" fontSize="32" fill="#E8A317">P</text>
      </svg>
    </div>
    <span className="text-sm font-bold text-white">Phantom Trades</span>
  </div>
);

export default Logo;
